import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const ConfiguracionReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(Types.CONSULTAR_CARGA_PANTALLAS_LOADING, (state) => {
      state.consultarCargaPantallasLoading = true;
      state.consultarCargaPantallasError = null;
    })
    .addCase(Types.CONSULTAR_CARGA_PANTALLAS_SUCCESS, (state, action) => {
      const { consultarCargaPantallasData } = action;
      state.consultarCargaPantallasData = consultarCargaPantallasData;
      state.consultarCargaPantallasLoading = false;
      state.consultarCargaPantallasError = null;
    })
    .addCase(Types.CONSULTAR_CARGA_PANTALLAS_FAILURE, (state, action) => {
      const { consultarCargaPantallasError } = action;
      state.consultarCargaPantallasData = INITIAL_STATE.consultarCargaPantallasData;
      state.consultarCargaPantallasLoading = false;
      state.consultarCargaPantallasError = consultarCargaPantallasError;
    });
});

